export default class Api {

  public static get BaseUrl() {
    return process.env.REACT_APP_API_URL || '';
  }
  
}
